import React, { useState, useEffect } from 'react'

import {
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  Divider,
  Flex,
  Input,
  Menu,
  MenuButton,
  MenuGroup,
  MenuList,
  Text,
} from '@chakra-ui/react'

const MultipleSelectFilter = ({ value, setValue, options, direction = 'column' }) => {
  const [optionFilter, setOptionFilter] = useState('')

  const selectValues = value ?? []

  //Translated
  const allChecked = selectValues && selectValues.length === options.length + 1
  const isIndeterminate = Array.isArray(selectValues) && selectValues.length > 0 && !allChecked
  const filteredOptions = options.filter((opt) => opt.label.toLowerCase().includes(optionFilter.toLowerCase()))

  const handleSetFilter = (data) => {
    setValue(data)
  }

  const handleSelectAll = () => {
    if (allChecked) {
      setValue([])
    } else {
      setValue(['__blank', ...options.map((opt) => opt.value)])
    }
  }

  const handleFilterOptions = (e) => {
    const filterString = e.target.value
    setOptionFilter(filterString)
  }

  const handleSelectBlank = (e) => {
    const isChecked = e.target.checked
    if (isChecked) {
      setValue(['__blank'])
    } else {
      setValue([])
    }
  }

  return (
    <Flex direction={direction} gap="3" px="4">
      <Input type="text" placeholder="Filter by" onChange={handleFilterOptions} />
      <Divider />

      <Checkbox colorScheme="teal" isChecked={allChecked} isIndeterminate={isIndeterminate} onChange={handleSelectAll}>
        All
      </Checkbox>
      <Box maxHeight="200px" overflowY={'scroll'}>
        <CheckboxGroup colorScheme="teal" value={selectValues} onChange={handleSetFilter}>
          <Flex gap="3" direction={'column'}>
            <Checkbox colorScheme="teal" value={'__blank'}>
              <Text textAlign={'start'}>(Blank)</Text>
            </Checkbox>
            {filteredOptions.map((option) => (
              <Checkbox key={option.value} value={option.value}>
                <Text textAlign={'start'}> {option.label}</Text>
              </Checkbox>
            ))}
          </Flex>
        </CheckboxGroup>
      </Box>
    </Flex>
  )
}

export default React.memo(MultipleSelectFilter)
